import React from 'react';

const Socials = () => {
  return (
    <div class = "home__socials">
        <a href = "https://www.instagram.com/ayushii_uniyal/" className = "home__social-link" target = "_blank">
            <i className="fa-brands fa-instagram"></i>        
        </a>

        <a href = "https://www.linkedin.com/in/ayushi-uniyal-84435225b/" className = "home__social-link" target = "_blank">
            <i className="fa-brands fa-linkedin"></i>
        </a>

        <a href = "https://github.com/Ayushii-uniyal" className = "home__social-link" target = "_blank">
            <i className="fa-brands fa-github"></i>
        </a>        
    </div>
  )
}

export default Socials
